import { Component } from '@angular/core';

@Component({
  selector: 'app-cards8-examples-53',
  templateUrl: './cards8-examples-53.component.html'
})
export class Cards8Examples53Component {}
